import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class ApplicationProgramsService {

  apiUrl = environment.apiUrl

  httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient,private _authservice:AuthService) { }

  private authHeaders(): HttpHeaders {
    const token = this._authservice.getAuthToken();
    return new HttpHeaders({ 'Authorization': 'Bearer ' + token });
  }

  private withProgramMode(params?: HttpParams): HttpParams {
    let p = params || new HttpParams();
    const mode = this._authservice.getEffectiveProgramMode();
    return p.set('programMode', mode);
  }

  getCoursePrograms():Observable<any>
  {
    return this.http.get<any[]>(this.apiUrl+'program/getCoursePrograms',{
      headers: this.authHeaders(),
      params: this.withProgramMode()
    })
  }

  getCoachedPrograms():Observable<any>
  {
    return this.http.get<any[]>(this.apiUrl+'program/getCoachedPrograms',{headers: this.authHeaders()})
  }

  getLLTTFPrograms():Observable<any>
  {
    return this.http.get<any[]>(this.apiUrl+'program/getLLTTFPrograms',{headers: this.authHeaders()})
  }

  getProgramsForUserListing():Observable<any>
  {
    return this.http.get<any[]>(this.apiUrl+'program/getProgramsForUserListing',{
      headers: this.authHeaders(),
      params: this.withProgramMode()
    })
  }
}
